
<script>

let validateRequire = function(value, inputParameter) {
  value = typeof value === String ? value.trim() : value;
  if(value === null ||
  value === undefined ||
  value === '') {
    return 'This field is required';
  }
};

let validateEmail = function(value, inputParameter) {
  if(value === null ||
  value === undefined ||
  value === '') {
    return;
  }

  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if(!re.test(value)) {
    return 'Please enter valid email format';
  }
};

let validatePhone = function(value, inputParameter) {
  if(value === null ||
  value === undefined ||
  value === '') {
    return;
  }

  var re = /^[\+]?[(]?[0-9]{2,4}[)]?[-\s\.]?[0-9]{3,5}[-\s\.]?[0-9]{3,6}$/im;
  if(!re.test(value)) {
    return 'Please enter valid phone format';
  }
};


let validateMax = function(value, inputParameter, formIsAdd) {
  var customAttr = formIsAdd ? inputParameter.form_add_input_attr : inputParameter.form_edit_input_attr;
  var max = Object.assign({}, inputParameter.form_input_attr, customAttr).max;
  value = parseInt(value);
  
  if(isNaN(max)) {
    return;
  }

  if(value > max) {
    return 'Value cannot be more than ' + max;
  }
};


let validatePositive = function(value, inputParameter, formIsAdd) {
  value = parseInt(value);
  if(value < 0) {
    return 'Value cannot be negative';
  }
};

export default {
  validateRequire,
  validateEmail,
  validatePhone,
  validateMax,
  validatePositive,
};
</script>


// WEBPACK FOOTER //
// src/components/Utility/Validation.vue